/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Client_Portal_EmailInputs */

const cs_client_portal_email = /** @type {(inputs: Client_Portal_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlašovací e-mail portálu`)
};

const en_client_portal_email = /** @type {(inputs: Client_Portal_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Portal login e-mail`)
};

/**
* | output |
* | --- |
* | "Portal login e-mail" |
*
* @param {Client_Portal_EmailInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const client_portal_email = /** @type {((inputs?: Client_Portal_EmailInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Client_Portal_EmailInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_client_portal_email(inputs)
	return cs_client_portal_email(inputs)
});